import React from "react";

import SessionInputView from "./SessionInputView";
import useSessionInputStep from "./useSessionInputStep";

const SessionInputStep = ({ onNext, onBack, setInputsGenerados }) => {
  const sessionInput = useSessionInputStep({ onNext, setInputsGenerados });

  return (
    <SessionInputView
      {...sessionInput}
      onBack={onBack}
    />
  );
};

export default SessionInputStep;
